<app-change-course-header [showChangeCourse]="false"></app-change-course-header>
<div class="row px-2 mt-2">
  <h6 class="px-0">
    <strong> Mock Exam Id: </strong> {{ MockExamId }}
    <strong class="ms-5"> Mock Exam #: </strong> {{ MockExamSequenceNumber }}
  </h6>
</div>
<div class="row d-flex px-2">
  <h6 class="px-0 my-2">
    <strong>Number of Questions in Mock Exam:</strong>
    <span style="color: #e542a3">
      {{ subjects[0]?.Current_Number_Of_Question }}
    </span>
    / {{ subjects[0]?.Total_Number_Of_Question }}
  </h6>
</div>

<div class="row px-2">
  <h5 class="px-0 mt-4 mb-2">
    <strong> Subject: </strong>
  </h5>
</div>

<div class="row">
  <div class="container">
    <!-- Subject Section -->
    <div *ngFor="let subject of subjects">
      <p>
        <button
        type="button"
        class="toggle-btn-mock-exam"
        style="color: #0c4788;"
        [ngStyle]="{
          cursor: subject.Subject_Current_Number_Of_Question < subject.Subject_Total_Number_Of_Question ? 'pointer' : 'not-allowed'

        }"
        [attr.aria-expanded]="!subject.isCollapsed"

        (click)="
        subject.Subject_Current_Number_Of_Question > 0
          ? (subjectIdOpen = subjectIdOpen === subject.Subject_Id ? null : subject.Subject_Id)
          : null
      "
      >
          {{ subject.Subject_Name }}:
          <span
            style="color: black; margin: 0 10px"
            [ngClass]="{
              'text-danger':
                subject.Subject_Current_Number_Of_Question <
                subject.Subject_Total_Number_Of_Question
            }"
          >
            {{ subject.Subject_Current_Number_Of_Question }}
          </span>

          / <span class="text-dark">{{ subject.Subject_Total_Number_Of_Question }}</span>
          <i
            class="fa fa-angle-right"
            *ngIf="subject.isCollapsed && subject.Subject_Current_Number_Of_Question"
          ></i>
          <i
            class="fa fa-angle-down"
            *ngIf="!subject.isCollapsed && subject.Subject_Current_Number_Of_Question"
          ></i>
          <i
            class="fa fa-plus-circle"
            *ngIf="
              subject.Subject_Current_Number_Of_Question !=
              subject.Subject_Total_Number_Of_Question
            "
            (click)="AddEditQuestion(subject)"
          ></i>
        </button>
      </p>
      <div #collapse="ngbCollapse" [ngbCollapse]="subjectIdOpen !== subject.Subject_Id">
        <div class="card">
          <div class="card-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 0%; text-align: center; vertical-align: middle;">Question Number</th>
                  <th style="width: 15%; text-align: center; vertical-align: middle;">Topic</th>
                  <th style="width: 2%; text-align: center; vertical-align: middle;">Question Id</th>
                  <th style="width: 15%; text-align: center; vertical-align: middle;">Question</th>
                  <th style="width: 25%; text-align: center; vertical-align: middle;">Answer Choices</th>
                  <th style="width: 2%; text-align: center; vertical-align: middle;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let question of subject.questions; let i = index">
                  <td class="text-center align-middle">{{ i + 1 }}</td>
                  <td class="align-middle">{{ question.Path_Name }}</td>
                  <td class="align-middle">{{ question.Question_ID }}</td>
                  <td
                    class="align-middle"
                    [innerHTML]="question.Question_Text"
                  ></td>
                  <td class="align-middle">
                    <ul class="list-unstyled">
                      <li *ngFor="let choice of question.Answer_Choices">
                        <div class="d-flex gap-2">

                            <div class="d-flex align-baseline gap-1">
                              <input
                              type="checkbox"
                              class="form-check-input me-2"
                              [disabled]="true"
                              [checked]="choice.Selected_IND === 'Y'"
                            />
                              <strong *ngIf="choice.Right_Answer_Ind === 'Y'">[R]</strong>
                              <span [innerHTML]="choice.Answer_Choice_Text"></span>
                            </div>
                       <!-- <strong *ngIf="choice.Right_Answer_Ind ==='Y'">[R]</strong> <span [innerHTML]="choice.Answer_Choice_Text"></span> -->
                      </div>
                      </li>
                    </ul>
                  </td>
                  <td class="align-middle text-center">
                    <i class="fa fa-trash pointer-cursor" (click)="onDelete(subject,question)"></i>
                    <i class="fa fa-pencil pointer-cursor ms-2" (click)="onEdit(subject,question)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
